import { render } from "./BannerEdit.vue?vue&type=template&id=65745f6d"
import script from "./BannerEdit.vue?vue&type=script&lang=js"
export * from "./BannerEdit.vue?vue&type=script&lang=js"
script.render = render

export default script